import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const ASSUNTOS_URL = BASE_URL + "pje/seam/resource/rest/pje-legacy/ApoioIRDR/assunto"
export const useTemaAssuntoStore = defineStore('temaAssunto', {
  state: () => ({
    assuntos: [],
    filtered: [],
    assuntoAllList: [],
    params: {
      codigo: null,
      descricao: null
    }
  }),
  getters: {
    all: state => state.assuntos,
  },
  actions: {
    async fetch(params) {
      this.params = params
      const paramsString = `?codigo=${encodeURIComponent(params?.codigo || "")}&descricao=${encodeURIComponent(params?.descricao || "")}`;
      const { data } = await Axios.get(ASSUNTOS_URL + paramsString)
      this.assuntos = Object.entries(data).map(assunto => ({ codigo: assunto[0], descricao: assunto[1] + " - " + assunto[0] }))
      this.assuntoAllList = Object.entries(data).map(assunto => ({ codigo: assunto[0], descricao: assunto[1] + " - " + assunto[0] }))
      this.assuntos.sort((a, b) => a.descricao.localeCompare(b.descricao))
      this.assuntoAllList.sort((a, b) => a.descricao.localeCompare(b.descricao))
      this.filtered = this.assuntos
      return this.assuntos
    },
    async fetchRamos() {
      const paramsString = `?codigo=${encodeURIComponent("")}&descricao=${encodeURIComponent("")}&raiz=${encodeURIComponent(true)}`;
      const { data } = await Axios.get(ASSUNTOS_URL + paramsString)
      this.assuntos = Object.entries(data).map(assunto => ({ codigo: assunto[0], descricao: assunto[1] }))
      this.filtered = this.assuntos
      return this.assuntos
    },
  },
})
